export const routerAdvertisingList = [
  {
    path: '/toBeDone',
    name: 'to_be_done',
    meta: {
      title: '待办事项'
    },
    component: () => import('@/views/toBeDone/index.vue'),
    children: []
  }, {
    path: '/dataBoard',
    name: 'data_board',
    meta: {
      title: '数据看板'
    },
    children: [
      {
        path: '/dataBoard/blocData',
        name: 'data_board_bloc_data',
        meta: {
          title: '集团数据'
        },
        component: () => import('@/views/dataBoard/blocData/index.vue'),
        children: []
      }, {
        path: '/dataBoard/adData',
        name: 'data_board_ad_data',
        meta: {
          title: '广告事业部数据'
        },
        component: () => import('@/views/dataBoard/adData/index.vue'),
        children: []
      }, {
        path: '/dataBoard/mediumData',
        name: 'data_board_medium_data',
        meta: {
          title: '媒介数据'
        },
        component: () => import('@/views/dataBoard/mediumData/index.vue'),
        children: []
      }, {
        path: '/dataBoard/projectData',
        name: 'data_board_project_data',
        meta: {
          title: '项目组数据'
        },
        component: () => import('@/views/dataBoard/projectData/index.vue'),
        children: []
      },
      // {
      //   path: '/dataBoard/pitcherData',
      //   name: 'data_board_pitcher_data',
      //   meta: {
      //     title: '投手数据'
      //   },
      //   component: () => import('@/views/dataBoard/pitcherData/index.vue'),
      //   children: []
      // }, 
      // {
      //   path: '/dataBoard/daiOrdersData',
      //   name: 'data_board_dai_order_data',
      //   meta: {
      //     title: '代下单数据'
      //   },
      //   component: () => import('@/views/dataBoard/daiOrdersData/index.vue'),
      //   children: []
      // },
      {
        path: '/dataBoard/redBroker',
        name: 'data_board_red_broker',
        meta: {
          title: '红人经纪人数据'
        },
        component: () => import('@/views/dataBoard/redBroker/index.vue'),
        children: []
      }, {
        path: '/dataBoard/redBusiness',
        name: 'data_board_red_business',
        meta: {
          title: '红人商务数据'
        },
        component: () => import('@/views/dataBoard/redBusiness/index.vue'),
        children: []
      },
      {
        path: '/dataBoard/rouWen',
        name: 'data_board_rou_wen',
        meta: {
          title: '肉雯数据'
        },
        component: () => import('@/views/dataBoard/rouWen/index.vue'),
        children: []
      },
      {
        path: '/dataBoard/pitcher',
        name: 'data_board_pitcher',
        meta: {
          title: '运营数据'
        },
        component: () => import('@/views/dataBoard/pitcher/index.vue'),
        children: []
      }
    ]
  }, {
    path: '/talentScreening',
    name: 'talent_screening_name',
    meta: {
      title: '达人筛选'
    },
    component: () => import('@/views/talentScreening/index.vue'),
    children: []
  }, {
    path: '/talentScreening/talentDetails',
    name: 'talent_details',
    meta: {
      title: '达人详情'
    },
    hiddenMenu: true,
    component: () => import('@/views/talentDetails/index.vue'),
    children: []
  }, {
    path: '/inventory',
    name: 'inventory',
    meta: {
      title: '达人清单'
    },
    children: [],
    component: () => import('@/views/inventory/index.vue')
  }, {
    path: '/inventory/inventoryDetails',
    name: 'inventory_details',
    meta: {
      title: '清单详情'
    },
    hiddenMenu: true,
    component: () => import('@/views/inventoryDetails/index.vue'),
    children: []
  }, {
    path: '/ai/commentAnalysis',
    name: 'ai_comment_analysis',
    meta: {
      title: '评论监测'
    },
    component: () => import('@/views/ai/commentAnalysis/index.vue'),
    children: []
  }, {
    path: '/throwInManage',
    name: 'throwInManage',
    meta: {
      title: '广告事业部'
    },
    children: [
      {
        path: '/throwInManage/projectManage',
        name: 'project_manage',
        meta: {
          title: '项目合同管理'
        },
        component: () => import('@/views/throwInManage/projectManage/index.vue'),
        children: []
      }, {
        path: '/throwInManage/projectManage/projectApproval',
        name: 'project_approval',
        meta: {
          title: '项目立项'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/projectManage/addProject/index.vue'),
        children: []
      }, {
        path: '/throwInManage/projectManage/details',
        name: 'project_details',
        meta: {
          title: '项目详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/projectManage/projectDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/poOrder',
        name: 'inner_order_po_order',
        meta: {
          title: 'PO列表'
        },
        component: () => import('@/views/throwInManage/innerOrder/poOrder/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/poOrder/addPoOrder',
        name: 'inner_order_add_po_order',
        meta: {
          title: '新增PO单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/poOrder/addPoOrder.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/poOrder/poOrderDetails',
        name: 'inner_order_po_order_details',
        meta: {
          title: 'PO单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/poOrder/poOrderDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/authorPurchase',
        name: 'inner_order_author_purchase',
        meta: {
          title: '达人采买列表'
        },
        component: () => import('@/views/throwInManage/innerOrder/authorPurchase/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/addOrder',
        name: 'inner_order_order_add',
        meta: {
          title: '新增订单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/authorPurchase/addOrder/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/fatherDetails',
        name: 'inner_order_order_details',
        meta: {
          title: '订单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/authorPurchase/fatherOrderInfoModule/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/childDetails',
        name: 'inner_order_order_child_details',
        meta: {
          title: '订单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/authorPurchase/childOrderInfoModule/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/streamDetails',
        name: 'inner_order_stream_details',
        meta: {
          title: '投后数据'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/authorPurchase/streamDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/adFeed',
        name: 'inner_order_ad_feed',
        meta: {
          title: '广告投流列表'
        },
        component: () => import('@/views/throwInManage/innerOrder/adFeed/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/adFeed/addAdFeed',
        name: 'inner_order_add_ad_feed',
        meta: {
          title: '广告投流'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/adFeed/addAdFeed/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/adFeed/incomeExpenditure',
        name: 'inner_order_income_expenditure',
        meta: {
          title: '广告投流'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/adFeed/addAdFeed/incomeExpenditure.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/adFeed/adFeedDetails',
        name: 'inner_order_ad_feed_details',
        meta: {
          title: '投流单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/adFeed/adFeedDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/adFeed/adFeedConsumeDetails',
        name: 'inner_order_ad_feed_consume_details',
        meta: {
          title: '投流消耗单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/adFeed/adFeedDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/adFeed/adFeedBillDetails',
        name: 'inner_order_ad_feed_bill_details',
        meta: {
          title: '投流收支详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/adFeed/adFeedDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/hardHiro',
        name: 'inner_order_hard_hiro',
        meta: {
          title: '硬广列表'
        },
        component: () => import('@/views/throwInManage/innerOrder/hardHiro/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/hardHiro/addHardHiro',
        name: 'inner_order_add_hard_hiro',
        meta: {
          title: '新增硬广'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/hardHiro/addHardHiro/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/hardHiro/hardHiroDetails',
        name: 'inner_order_hard_hiro_details',
        meta: {
          title: '硬广详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/hardHiro/hardHiroDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/projectServiceCharge',
        name: 'project_service_charge',
        meta: {
          title: '项目服务费'
        },
        component: () => import('@/views/throwInManage/innerOrder/projectServiceCharge/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/projectServiceCharge/addProjectServiceCharge',
        name: 'add_project_service_charge',
        meta: {
          title: '新增项目服务费'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/projectServiceCharge/addProjectServiceCharge.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/projectServiceCharge/projectServiceChargeDetails',
        name: 'project_service_charge_details',
        meta: {
          title: '项目服务费详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/projectServiceCharge/projectServiceChargeDetails.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/other',
        name: 'other_expenses',
        meta: {
          title: '其他开销'
        },
        component: () => import('@/views/throwInManage/innerOrder/other/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/other/addOther',
        name: 'offline_payment_add_other',
        meta: {
          title: '申请其他开销单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/other/addOther/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/other/otherDetails',
        name: 'offline_payment_other_details',
        meta: {
          title: '其他开销单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/other/otherDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/authorPurchase',
        name: 'offline_payment_author_purchase',
        meta: {
          title: '线下采买付款'
        },
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/addPurchaseOrder',
        name: 'offline_payment_add_author_order',
        meta: {
          title: '供应商采购下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/addOrder/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/addReplaceOrder',
        name: 'offline_payment_add_replace_order',
        meta: {
          title: '供应商代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/addOrder/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/addPublicTransfer',
        name: 'offline_payment_add_public_transfer',
        meta: {
          title: '达人对公转账'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/addOrder/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/addPrivateTransfer',
        name: 'offline_payment_add_private_transfer',
        meta: {
          title: '达人对私转账'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/addOrder/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/addFlexibleLaborOrder',
        name: 'offline_payment_add_flexible_labor_order',
        meta: {
          title: '灵活用工下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/addOrder/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/purchaseOrderDetails',
        name: 'offline_payment_purchase_order_details',
        meta: {
          title: '供应商采购下单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/orderDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/replaceOrderDetails',
        name: 'offline_payment_replace_order_details',
        meta: {
          title: '供应商代下单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/orderDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/publicTransferDetails',
        name: 'offline_payment_public_transfer_details',
        meta: {
          title: '达人对公转账详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/orderDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/privateTransferDetails',
        name: 'offline_payment_private_transfer_details',
        meta: {
          title: '达人对私转账详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/orderDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/flexibleLaborOrderDetails',
        name: 'offline_payment_flexible_labor_order_details',
        meta: {
          title: '灵活用工下单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/authorPurchase/orderDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/adFeed',
        name: 'offline_payment_ad_feed',
        meta: {
          title: '线下投流付款'
        },
        component: () => import('@/views/throwInManage/offlinePaymentOrder/adFeed/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/adFeed/addAdFeed',
        name: 'offline_payment_add_ad_feed',
        meta: {
          title: '线下投流付款申请付款'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/adFeed/addAdFeed/index.vue'),
        children: []
      }, {
        path: '/throwInManage/offlinePayment/adFeed/adFeedDetails',
        name: 'offline_payment_ad_feed_details',
        meta: {
          title: '线下投流付款详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/offlinePaymentOrder/adFeed/adFeedDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/saleRebate',
        name: 'inner_sale_rebate',
        meta: {
          title: '内部销售返点'
        },
        component: () => import('@/views/throwInManage/innerOrder/saleRebate/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/saleRebate/addSaleRebate',
        name: 'inner_sale_rebate_add',
        meta: {
          title: '申请内部销售返点'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/saleRebate/addSaleRebate/index.vue'),
        children: []
      }, {
        path: '/throwInManage/innerOrder/saleRebate/saleRebateDetails',
        name: 'inner_sale_rebate_details',
        meta: {
          title: '内部销售返点详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/innerOrder/saleRebate/saleRebateDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/authorPurchase',
        name: 'outer_order_author_purchase',
        meta: {
          title: '达人采买代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/authorPurchase/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/authorPutin',
        name: 'outer_order_author_putin',
        meta: {
          title: '达人投放信息'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/authorPutin/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/authorPurchase/addAuthorPurchase',
        name: 'inner_order_add_author_purchase',
        meta: {
          title: '新增达人采买代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/authorPurchase/addAuthorPurchase/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/authorPurchase/authorPurchaseDetails',
        name: 'outer_order_author_purchase_details',
        meta: {
          title: '达人采买代下单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/authorPurchase/authorPurchaseDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/adFeed',
        name: 'outer_order_ad_feed',
        meta: {
          title: '广告投流代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/adFeed/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/subAccountRecharge',
        name: 'outer_order_sub_account_recharge',
        meta: {
          title: '子账号充值'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/subAccountRecharge/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/subAccountRecharge/details',
        name: 'outer_order_sub_account_recharge_details',
        meta: {
          title: '子账号充值详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/subAccountRecharge/details.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/adFeed/addAdFeed',
        name: 'outer_order_add_ad_feed',
        meta: {
          title: '新增广告投流代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/adFeed/addAdFeed/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/adFeed/adFeedDetails',
        name: 'outer_order_ad_feed_details',
        meta: {
          title: '广告投流代下单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/adFeed/adFeedDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/adFeed/adFeedConsumeDetails',
        name: 'outer_order_ad_feed_consume_details',
        meta: {
          title: '投流消耗单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/adFeed/adFeedDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/hardHiro',
        name: 'outer_order_hard_hiro',
        meta: {
          title: '硬广代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/hardHiro/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/hardHiro/addHardHiro',
        name: 'outer_order_add_hard_hiro',
        meta: {
          title: '新增硬广代下单'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/hardHiro/addHardHiro/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/hardHiro/hardHiroDetails',
        name: 'outer_order_hard_hiro_details',
        meta: {
          title: '硬广代下单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/hardHiro/hardHiroDetails/index.vue'),
        children: []
      },
      {
        path: '/throwInManage/projectSettlement',
        name: 'project_settlement_list',
        meta: {
          title: '项目结算'
        },
        component: () => import('@/views/throwInManage/projectSettlement/index.vue'),
        children: []
      }, {
        path: '/throwInManage/projectSettlement/addSettlement',
        name: 'project_settlement_add',
        meta: {
          title: '新增项目结算'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/projectSettlement/addSettlement/index.vue'),
        children: []
      }, {
        path: '/throwInManage/projectSettlement/settlementDetails',
        name: 'project_settlement_details',
        meta: {
          title: '结算详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/projectSettlement/settlementDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder',
        name: 'outer_order',
        meta: {
          title: '外部下单管理'
        },
        component: () => import('@/views/throwInManage/outerOrder/order/index.vue'),
        children: []
      }, {
        path: '/throwInManage/saleRebate_outer',
        name: 'outer_order_sale_rebate_outer',
        meta: {
          title: '外部销售返点'
        },
        component: () => import('@/views/throwInManage/outerOrder/saleRebate/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/saleRebate',
        name: 'outer_order_sale_rebate',
        meta: {
          title: '销售返点'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/saleRebate/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/saleRebate/addSaleRebate',
        name: 'outer_order_add_sale_rebate',
        meta: {
          title: '新增销售返点'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/saleRebate/addSaleRebate/index.vue'),
        children: []
      }, {
        path: '/throwInManage/outerOrder/saleRebate/saleRebateDetails',
        name: 'outer_order_sale_rebate_details',
        meta: {
          title: '销售返点详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/outerOrder/saleRebate/saleRebateDetails/index.vue'),
        children: []
      }, {
        path: '/throwInManage/authorRebateBadDebt',
        name: 'author_rebate_bad_debt',
        meta: {
          title: '达人返点坏账'
        },
        component: () => import('@/views/throwInManage/authorRebateBadDebt/index.vue'),
        children: []
      }, {
        path: '/throwInManage/authorRebateBadDebt/badDebtDetails',
        name: 'author_rebate_bad_debt_details',
        meta: {
          title: '达人返点坏账详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/authorRebateBadDebt/badDebtDetails.vue'),
        children: []
      }
    ]
  }, {
    path: '/adProfessional',
    name: 'ad_professional',
    meta: {
      title: '投流专用'
    },
    children: [
      {
        path: '/adProfessional/creativity',
        name: 'ad_professional_creativity',
        meta: {
          title: '创意查询'
        },
        component: () => import('@/views/adProfessional/creativity/index.vue'),
        children: []
      },
      // {
      //   path: '/adProfessional/offlineReport',
      //   name: 'ad_professional_offline_report',
      //   meta: {
      //     title: '创意离线报告'
      //   },
      //   component: () => import('@/views/adProfessional/offlineReport/index.vue'),
      //   children: []
      // },
      {
        path: '/adProfessional/dailyReport',
        name: 'ad_professional_daily_report',
        meta: {
          title: '数据报表'
        },
        component: () => import('@/views/adProfessional/dailyReport/index.vue'),
        children: []
      }, {
        path: '/adProfessional/wordPackage',
        name: 'ad_professional_word_package',
        meta: {
          title: '词包管理'
        },
        component: () => import('@/views/adProfessional/wordPackage/index.vue'),
        children: []
      }, {
        path: '/adProfessional/accountUpdate',
        name: 'ad_professional_account_update',
        meta: {
          title: '账户更新'
        },
        component: () => import('@/views/adProfessional/accountUpdate/index.vue'),
        children: []
      },
      {
        path: '/adProfessional/plan',
        name: 'ad_professional_plan',
        meta: {
          title: '计划管理'
        },
        component: () => import('@/views/adProfessional/plan/index.vue'),
        children: []
      }, {
        path: '/adProfessional/plan/addPlan',
        name: 'ad_professional_add_plan',
        meta: {
          title: '新增计划'
        },
        hiddenMenu: true,
        component: () => import('@/views/adProfessional/plan/addPlan.vue'),
        children: []
      }, {
        path: '/adProfessional/plan/planDetails',
        name: 'ad_professional_plan_details',
        meta: {
          title: '计划详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/adProfessional/plan/planDetails.vue'),
        children: []
      }, {
        path: '/adProfessional/dailyPaper',
        name: 'ad_professional_daily_paper',
        meta: {
          title: '日报看板'
        },
        component: () => import('@/views/adProfessional/dailyPaper/index.vue'),
        children: []
      }, {
        path: '/adProfessional/note',
        name: 'ad_professional_note',
        meta: {
          title: '投流笔记'
        },
        component: () => import('@/views/adProfessional/note/index.vue'),
        children: []
      }
    ]
  }, {
    path: '/redMan',
    name: 'redMan',
    meta: {
      title: '红人事业部'
    },
    children: [
      {
        path: '/redMan/orderManage',
        name: 'red_order_manage',
        meta: {
          title: '订单管理'
        },
        component: () => import('@/views/redMan/orderManage/index.vue'),
        children: []
      }, {
        path: '/redMan/orderManage/addOrder',
        name: 'red_order_approval',
        meta: {
          title: '新增订单'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/orderManage/addOrder/index.vue'),
        children: []
      }, {
        path: '/redMan/orderManage/orderDetails',
        name: 'red_order_details',
        meta: {
          title: '订单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/orderManage/orderDetails/index.vue'),
        children: []
      }, {
        path: '/redMan/billManage',
        name: 'red_bill_manage',
        meta: {
          title: '账单管理'
        },
        component: () => import('@/views/redMan/billManage/index.vue'),
        children: []
      }, {
        path: '/redMan/billManage/addBill',
        name: 'red_add_bill_manage',
        meta: {
          title: '新增账单'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/billManage/addBill/index.vue'),
        children: []
      }, {
        path: '/redMan/billManage/billDetails',
        name: 'red_add_bill_details',
        meta: {
          title: '账单详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/billManage/billDetails/index.vue'),
        children: []
      }, {
        path: '/redMan/saleRebate',
        name: 'red_sale_rebate',
        meta: {
          title: '销售返点'
        },
        component: () => import('@/views/redMan/saleRebate/index.vue'),
        children: []
      }, {
        path: '/redMan/saleRebate/addSaleRebate',
        name: 'red_add_sale_rebate',
        meta: {
          title: '新增销售返点'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/saleRebate/addSaleRebate/index.vue'),
        children: []
      }, {
        path: '/redMan/saleRebate/saleRebateDetails',
        name: 'red_sale_rebate_details',
        meta: {
          title: '销售返点详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/saleRebate/saleRebateDetails/index.vue'),
        children: []
      }, {
        path: '/redMan/authorRemuneration',
        name: 'red_author_remuneration',
        meta: {
          title: '达人稿费'
        },
        component: () => import('@/views/redMan/authorRemuneration/index.vue'),
        children: []
      }, {
        path: '/redMan/authorRemuneration/addRemuneration',
        name: 'red_add_remuneration',
        meta: {
          title: '新增达人稿费'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/authorRemuneration/addRemuneration/index.vue'),
        children: []
      }, {
        path: '/redMan/authorRemuneration/remunerationDetails',
        name: 'red_remuneration_details',
        meta: {
          title: '达人稿费详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/redMan/authorRemuneration/remunerationDetails/index.vue'),
        children: []
      }
    ]
  }, {
    path: '/rouWen',
    name: 'rouWen',
    meta: {
      title: '肉雯事业部'
    },
    children: [
      {
        path: '/rouWen/projectManage',
        name: 'rouWen_project_manage',
        meta: {
          title: '项目管理'
        },
        component: () => import('@/views/rouWen/projectManage/index.vue'),
        children: []
      }, {
        path: '/rouWen/projectManage/addProject',
        name: 'rouWen_add_project',
        meta: {
          title: '新增项目'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/projectManage/addProject/index.vue'),
        children: []
      }, {
        path: '/rouWen/projectManage/projectDetails',
        name: 'rouWen_project_details',
        meta: {
          title: '项目详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/projectManage/projectDetails/index.vue'),
        children: []
      }, {
        path: '/rouWen/orderManage/authorNote',
        name: 'rouWen_order_manage_author_note',
        meta: {
          title: '达人笔记'
        },
        component: () => import('@/views/rouWen/orderManage/authorNote/index.vue'),
        children: []
      }, {
        path: '/rouWen/orderManage/authorNote/addAuthorNote',
        name: 'rouWen_order_manage_add_author_note',
        meta: {
          title: '新增笔记'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/orderManage/authorNote/addAuthorNote/index.vue'),
        children: []
      }, {
        path: '/rouWen/orderManage/authorNote/authorNoteDetails',
        name: 'rouWen_order_manage_author_note_details',
        meta: {
          title: '笔记详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/orderManage/authorNote/authorNoteDetails/index.vue'),
        children: []
      }, {
        path: '/rouWen/orderManage/jgPutFlow',
        name: 'rouWen_order_manage_jg_put_flow',
        meta: {
          title: '聚光投流'
        },
        component: () => import('@/views/rouWen/orderManage/jgPutFlow/index.vue'),
        children: []
      }, {
        path: '/rouWen/orderManage/jgPutFlow/addJgPutFlow',
        name: 'rouWen_order_manage_add_jg_put_flow',
        meta: {
          title: '新增聚光投流'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/orderManage/jgPutFlow/addJgPutFlow/index.vue'),
        children: []
      }, {
        path: '/rouWen/orderManage/jgPutFlow/jgPutFlowDetails',
        name: 'rouWen_order_manage_jg_put_flow_details',
        meta: {
          title: '聚光投流详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/orderManage/jgPutFlow/jgPutFlowDetails/index.vue'),
        children: []
      }, {
        path: '/rouWen/saleRebate',
        name: 'rouWen_sale_rebate',
        meta: {
          title: '销售返点'
        },
        component: () => import('@/views/rouWen/saleRebate/index.vue'),
        children: []
      }, {
        path: '/rouWen/saleRebate/addSaleRebate',
        name: 'rouWen_add_sale_rebate',
        meta: {
          title: '新增销售返点'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/saleRebate/addSaleRebate/index.vue'),
        children: []
      }, {
        path: '/rouWen/saleRebate/saleRebateDetails',
        name: 'rouWen_sale_rebate_details',
        meta: {
          title: '销售返点详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/saleRebate/saleRebateDetails/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/plan',
        name: 'rouWen_live_stream_plan',
        meta: {
          title: '直播计划'
        },
        component: () => import('@/views/rouWen/liveStream/plan/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/plan/addPlan',
        name: 'rouWen_live_stream_add_plan',
        meta: {
          title: '新增直播计划'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/liveStream/plan/addPlan/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/plan/planDetails',
        name: 'rouWen_live_stream_plan_details',
        meta: {
          title: '直播计划详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/liveStream/plan/planDetails/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/expenditure',
        name: 'rouWen_live_stream_expenditure',
        meta: {
          title: '直播支出'
        },
        component: () => import('@/views/rouWen/liveStream/expenditure/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/expenditure/addExpenditure',
        name: 'rouWen_live_stream_add_expenditure',
        meta: {
          title: '新增直播支出'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/liveStream/expenditure/addExpenditure/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/expenditure/expenditureDetails',
        name: 'rouWen_live_stream_expenditure_details',
        meta: {
          title: '直播支出详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/liveStream/expenditure/expenditureDetails/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/commission',
        name: 'rouWen_live_stream_commission',
        meta: {
          title: '直播佣金'
        },
        component: () => import('@/views/rouWen/liveStream/commission/index.vue'),
        children: []
      }, {
        path: '/rouWen/liveStream/commission/commissionDetails',
        name: 'rouWen_live_stream_commission_details',
        meta: {
          title: '直播佣金详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/rouWen/liveStream/commission/commissionDetails/index.vue'),
        children: []
      }
    ]
  }, {
    path: '/financialManage',
    name: 'financial',
    meta: {
      title: '财务管理'
    },
    children: [
      {
        path: '/financialManage/invoice',
        name: 'financial_invoice_list_1',
        meta: {
          title: '客户/供应商开票'
        },
        component: () => import('@/views/financialManage/invoice/index.vue'),
        children: []
      }, {
        path: '/financialManage/invoice/addInvoice',
        name: 'financial_add_invoice_1',
        meta: {
          title: '新增发票'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/invoice/addInvoice/index.vue'),
        children: []
      }, {
        path: '/financialManage/invoice/invoiceDetails',
        name: 'financial_invoice_details_1',
        meta: {
          title: '发票详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/invoice/invoiceDetails/index.vue'),
        children: []
      }, {
        path: '/financialManage/platformRebateInvoice',
        name: 'financial_platform_rebate_invoice',
        meta: {
          title: '平台返点开票'
        },
        component: () => import('@/views/financialManage/platformRebateInvoice/index.vue'),
        children: []
      }, {
        path: '/financialManage/platformRebateInvoice/addBlueInvoice',
        name: 'financial_platform_rebate_invoice_add_blue',
        meta: {
          title: '新增平台返点开蓝票'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/platformRebateInvoice/add/addBlueInvoice.vue'),
        children: []
      }, {
        path: '/financialManage/platformRebateInvoice/details',
        name: 'financial_platform_rebate_invoice_details',
        meta: {
          title: '平台返点开票详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/platformRebateInvoice/details/index.vue'),
        children: []
      },
      // {
      //   path: '/financialManage',
      //   name: 'financial_refund',
      //   meta: {
      //     title: '回款管理'
      //   },
      //   children: [
      //   ]
      // }, 
      {
        path: '/financialManage/clientRefundList',
        name: 'financial_client_refund_list',
        meta: {
          title: '客户回款/退款'
        },
        component: () => import('@/views/financialManage/clientRefund/index.vue'),
        children: []
      }, {
        path: '/financialManage/addClientRefund',
        name: 'financial_add_client_refund',
        meta: {
          title: '新增客户回款/退款'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/clientRefund/addClientRefund/index.vue'),
        children: []
      }, {
        path: '/financialManage/clientRefundDetails',
        name: 'financial_client_refund_details',
        meta: {
          title: '客户回款/退款详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/clientRefund/clientRefundDetails/index.vue'),
        children: []
      }, {
        path: '/financialManage/transferDetails',
        name: 'financial_transfer_details',
        meta: {
          title: '回款划转详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/clientRefund/transferDetails/index.vue'),
        children: []
      }, {
        path: '/financialManage/platformRefundList',
        name: 'financial_platform_refund_list',
        meta: {
          title: '平台返点回款'
        },
        component: () => import('@/views/financialManage/platformRefund/index.vue'),
        children: []
      }, {
        path: '/financialManage/addPlatformRefund',
        name: 'financial_add_platform_refund',
        meta: {
          title: '新增平台返点回款'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/platformRefund/addPlatformRefund/index.vue'),
        children: []
      }, {
        path: '/financialManage/platformRefundDetails',
        name: 'financial_platform_refund_details',
        meta: {
          title: '平台返点回款详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/financialManage/platformRefund/platformRefundDetails/index.vue'),
        children: []
      }, {
        path: '/financialManage/purse',
        name: 'financial_purse',
        meta: {
          title: '钱包管理'
        },
        children: [
          {
            path: '/financialManage/purse/fundPurse',
            name: 'financial_fund_purse_list',
            meta: {
              title: '资金钱包'
            },
            component: () => import('@/views/financialManage/purse/fundPurse/index.vue'),
            children: []
          }, {
            path: '/financialManage/purse/fundPurse/childPurse',
            name: 'financial_fund_child_purse_list',
            meta: {
              title: '子资金钱包'
            },
            hiddenMenu: true,
            component: () => import('@/views/financialManage/purse/fundPurse/childPurse/index.vue'),
            children: []
          }, {
            path: '/financialManage/purse/topUpApproval',
            name: 'financial_top_up_approval_list',
            meta: {
              title: '充值审批'
            },
            component: () => import('@/views/financialManage/purse/topUpApproval/index.vue'),
            children: []
          }, {
            path: '/financialManage/purse/topUpApproval/details',
            name: 'financial_top_up_approval_details',
            meta: {
              title: '充值审批详情'
            },
            hiddenMenu: true,
            component: () => import('@/views/financialManage/purse/topUpApproval/details.vue'),
            children: []
          }
        ]
      }, {
        path: '/financialManage/applicationPayment',
        name: 'application_payment_page',
        meta: {
          title: '打印记录'
        },
        component: () => import('@/views/throwInManage/applicationPayment/index.vue'),
        children: []
      }, {
        path: '/financialManage/applicationPayment/details',
        name: 'application_payment_details',
        meta: {
          title: '打印记录详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/throwInManage/applicationPayment/details.vue'),
        children: []
      }, {
        path: '/financialManage/historyReplenish',
        name: 'dev_history_replenish',
        meta: {
          title: '历史回款补录'
        },
        children: [],
        component: () => import('@/views/develop/historyReplenish.vue'),
      }
    ]
  }, {
    path: '/basicFile',
    name: 'basicFile',
    meta: {
      title: '基础档案'
    },
    children: [
      {
        path: '/basicFile/outsideAuthor',
        name: 'outside_author',
        meta: {
          title: '外部达人库'
        },
        component: () => import('@/views/basicFile/outsideAuthor/index.vue'),
        children: []
      }, {
        path: '/basicFile/outsideAuthor/addAuthor',
        name: 'outside_add_author',
        meta: {
          title: '新增外部达人库'
        },
        hiddenMenu: true,
        component: () => import('@/views/basicFile/outsideAuthor/addEditAuthor.vue'),
        children: []
      }, {
        path: '/basicFile/outsideAuthor/editAuthor',
        name: 'outside_edit_author',
        meta: {
          title: '编辑外部达人库'
        },
        hiddenMenu: true,
        component: () => import('@/views/basicFile/outsideAuthor/addEditAuthor.vue'),
        children: []
      }, {
        path: '/basicFile/outsideAuthor/authorDetails',
        name: 'outside_author_details',
        meta: {
          title: '外部达人详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/basicFile/outsideAuthor/authorDetails.vue'),
        children: []
      }, {
        path: '/basicFile/innerAuthor',
        name: 'inner_author',
        meta: {
          title: '内部达人库'
        },
        component: () => import('@/views/basicFile/innerAuthor/index.vue'),
        children: []
      }, {
        path: '/basicFile/innerAuthor/addAuthor',
        name: 'inner_add_author',
        meta: {
          title: '新增内部达人库'
        },
        hiddenMenu: true,
        component: () => import('@/views/basicFile/innerAuthor/addAuthor/index.vue'),
        children: []
      }, {
        path: '/basicFile/innerAuthor/editAuthor',
        name: 'inner_edit_author',
        meta: {
          title: '编辑内部达人库'
        },
        hiddenMenu: true,
        component: () => import('@/views/basicFile/innerAuthor/addAuthor/index.vue'),
        children: []
      }, {
        path: '/basicFile/innerAuthor/authorDetails',
        name: 'inner_author_details',
        meta: {
          title: '内部达人详情'
        },
        hiddenMenu: true,
        component: () => import('@/views/basicFile/innerAuthor/authorDetails/index.vue'),
        children: []
      }, {
        path: '/basicFile/customer',
        name: 'customer_name',
        meta: {
          title: '客户管理'
        },
        children: [],
        component: () => import('@/views/basicFile/customer/index.vue')
      }, {
        path: '/basicFile/customer/addCustomer',
        name: 'add_customer',
        meta: {
          title: '新增客户'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/customer/addEditCustomer.vue')
      }, {
        path: '/basicFile/customer/editCustomer',
        name: 'edit_customer',
        meta: {
          title: '编辑客户'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/customer/addEditCustomer.vue')
      }, {
        path: '/basicFile/customer/customerDetails',
        name: 'customer_etails',
        meta: {
          title: '客户详情'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/customer/customerDetails.vue')
      }, {
        path: '/basicFile/supplier',
        name: 'supplier_name',
        meta: {
          title: '供应商管理'
        },
        children: [],
        component: () => import('@/views/basicFile/supplier/index.vue')
      }, {
        path: '/basicFile/supplier/addSupplier',
        name: 'add_supplier',
        meta: {
          title: '新增供应商'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/supplier/addEditSupplier.vue')
      }, {
        path: '/basicFile/supplier/editSupplier',
        name: 'edit_supplier',
        meta: {
          title: '编辑供应商'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/supplier/addEditSupplier.vue')
      }, {
        path: '/basicFile/supplier/supplierDetails',
        name: 'supplier_etails',
        meta: {
          title: '供应商详情'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/supplier/supplierDetails.vue')
      }, {
        path: '/basicFile/account',
        name: 'account_name',
        meta: {
          title: '平台账户管理'
        },
        children: [],
        component: () => import('@/views/basicFile/account/index.vue')
      }, {
        path: '/basicFile/companyMainBody',
        name: 'companyMainBody',
        meta: {
          title: '公司主体信息管理'
        },
        children: [],
        component: () => import('@/views/basicFile/companyMainBody/index.vue')
      }, {
        path: '/basicFile/companyMainBody/addFlexibleEmployment',
        name: 'addFlexibleEmployment',
        meta: {
          title: '新增灵活用工'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/companyMainBody/addEditFlexibleEmployment.vue')
      }, {
        path: '/basicFile/companyMainBody/addCompanyMainBody',
        name: 'addCompanyMainBody',
        meta: {
          title: '新增公司主体'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/companyMainBody/addEditCompanyMainBody.vue')
      }, {
        path: '/basicFile/companyMainBody/editFlexibleEmployment',
        name: 'editFlexibleEmployment',
        meta: {
          title: '编辑灵活用工'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/companyMainBody/addEditFlexibleEmployment.vue')
      }, {
        path: '/basicFile/companyMainBody/editCompanyMainBody',
        name: 'editCompanyMainBody',
        meta: {
          title: '编辑公司主体'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/companyMainBody/addEditCompanyMainBody.vue')
      }, {
        path: '/basicFile/companyMainBody/companyMainBodyDetails',
        name: 'companyMainBodyDetails',
        meta: {
          title: '公司主体详情'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/companyMainBody/companyMainBodyDetails.vue')
      }, {
        path: '/basicFile/companyMainBody/flexibleEmploymentDetails',
        name: 'flexibleEmploymentDetails',
        meta: {
          title: '灵活用工详情'
        },
        children: [],
        hiddenMenu: true,
        component: () => import('@/views/basicFile/companyMainBody/flexibleEmploymentDetails.vue')
      }
    ],
  }, {
    path: '/develop',
    name: 'develop',
    meta: {
      title: '开发补充'
    },
    children: [
      {
        path: '/develop/basics',
        name: 'dev_basics',
        meta: {
          title: '基础补充'
        },
        children: [],
        component: () => import('@/views/develop/index.vue'),
      }, {
        path: '/develop/userJg',
        name: 'dev_userJg',
        meta: {
          title: '用户聚光归属'
        },
        children: [],
        component: () => import('@/views/develop/userJg.vue'),
      }, {
        path: '/develop/flowSubAccount',
        name: 'dev_flow_sub_account',
        meta: {
          title: '投流子账号'
        },
        children: [],
        component: () => import('@/views/develop/flowSubAccount.vue'),
      }
    ]
  }
];

export const routerBusinessList = [
  {
    path: '/business',
    name: 'business',
    meta: {
      title: '商业管理'
    },
    children: [
      {
        path: '/business/cstomer',
        name: 'business_cstomer',
        meta: {
          title: '客户列表'
        },
        children: [],
        component: () => import('@/views/business/cstomer/index.vue'),
      }
    ]
  }
];